import { cn } from '@/shared/utils/cn';
import { SeparatorProps } from '@/shared/types/separator';

/**
 * Separator - Componente de separador visual
 *
 * Componente que muestra una línea separadora horizontal o vertical.
 * Útil para dividir secciones de contenido visualmente.
 *
 * @example
 * ```tsx
 * // Separador horizontal
 * <Separator />
 *
 * // Separador vertical
 * <Separator vertical />
 *
 * // Separador sin padding
 * <Separator padding={false} />
 * ```
 *
 * @see {@link SeparatorProps} para la lista completa de props
 */
export const Separator = ({ className, vertical = false, padding = true }: SeparatorProps) => {
  return (
    <div
      className={cn(
        'ui-imj',
        'ui-border-default',
        className,
        padding ? '' : '',
        vertical ? 'ui-max-h-full ui-min-h-7 ui-border-r-1' : 'ui-w-full ui-border-t-1',
      )}
    />
  );
};
